/* eslint-disable no-underscore-dangle */

export const discoveryService = {
    get: (key: keyof typeof window.__flippingbook_discovery__) => window.__flippingbook_discovery__[key],
};
